<template>
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" :width="width" :height="height" version="1.1"
         style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
         viewBox="0 0 68 88"
         xmlns:xlink="http://www.w3.org/1999/xlink">
     <g id="Слой_x0020_1">
      <metadata id="CorelCorpID_0Corel-Layer"></metadata>
         <path class="shoulder-fill shoulder-stroke" :class="{'shoulder-active':selected}" d="M12 63c6,0 12,5 12,12 0,6 -5,12 -12,12 -6,0 -12,-5 -12,-12 0,-6 5,-12 12,-12z"></path>
         <path class="shoulder-fill shoulder-stroke" :class="{'shoulder-active':selected}" d="M17 73c3,-2 7,-4 10,-5 9,-4 19,-6 29,-6 -1,-2 -2,-4 -4,-7 -4,-5 -9,-10 -12,-13 -6,-7 -11,-12 -13,-23 -8,6 -11,22 -11,54z"></path>
         <path class="shoulder-fill shoulder-stroke" :class="{'shoulder-active':selected}" d="M17 73c-2,1 -3,2 -5,4 -6,-38 5,-68 24,-76 0,21 1,26 9,35 5,7 5,6 14,17 -1,6 -1,10 -1,10"></path>
         <path class="shoulder-fill shoulder-stroke" :class="{'shoulder-active':selected}" d="M56 50c6,0 12,5 12,12 0,6 -5,12 -12,12 -6,0 -12,-5 -12,-12 0,-6 5,-12 12,-12z"></path>
     </g>
</svg>

</template>

<script>
    import {implantMixin} from '@/mixins/implant.js'

    export default {
        mixins: [implantMixin]
    }
</script>

<style scoped>

</style>
